// Shared by manual RSVP replacement and editor publication. Event URL identity is unchanged.
function createPreviewVersion() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
module.exports = { createPreviewVersion };
